"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateDonationEvent = exports.Name = void 0;
const Name = exports.Name = 'update-donation';
const UpdateDonationEvent = exports.UpdateDonationEvent = Name;
